import { render, staticRenderFns } from "./trainingModulePageNew7.vue?vue&type=template&id=68213d00&scoped=true&"
import script from "./trainingModulePageNew7.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageNew7.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageNew7.vue?vue&type=style&index=0&id=68213d00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68213d00",
  null
  
)

export default component.exports